import { Box, BoxProps, ColorOptions, convertHexToRGBA, Text, TextProps } from '@jfs/ui-new'
import { FC, useEffect, useState } from 'react'
import { useLazyApiData, useStores } from '../../data/store'
import { getString } from '../../util/languageStrings'
import { Colors } from '../../util/util'

interface ResendOtpProps {
  count?: number
  mobile?: string
  color?: ColorOptions
  email?: string
  type?: 'EMAIL_OTP' | 'MOBILE_OTP'
}

const cdtStyles = (resendOtpColor: string) => {
  return {
    resendText: {
      fontFamily: 'JioType-Bold',
      fontSize: 14,
      letterSpacing: -0.07,
      color: resendOtpColor,
    } as TextProps,
  }
}

const getCountDownTime = (cdtimer: number) => {
  return cdtimer > 0 ? (cdtimer < 10 ? `00:0${cdtimer}` : `00:${cdtimer}`) : ''
}

const ResendOtp: FC<ResendOtpProps> = ({
  count = 0,
  mobile,
  email,
  color = 'PRIMARY',
  type = 'MOBILE_OTP',
}: ResendOtpProps) => {
  const { generateOtp, selectedAppLanguage, resendOtpAync } = useStores((root) => ({
    generateOtp: root.user.generateOtp,
    selectedAppLanguage: root.settings.config.selectedAppLanguage,
    resendOtpAync: root.user.session.resendOtpAync,
  }))

  const [countDowntimer, setCountDownTimer] = useState(count)
  const [resendOtp, { data }] = useLazyApiData(type === 'EMAIL_OTP' ? resendOtpAync : generateOtp)
  const error = data?.message ?? ''

  useEffect(() => {
    let timer: any
    if (countDowntimer > 0) {
      timer = setInterval(() => setCountDownTimer(countDowntimer - 1), 1000)
    }
    return () => clearInterval(timer)
  }, [countDowntimer])

  const resendOtpColor = countDowntimer > 0 ? ('LIGHT_BLACK' as ColorOptions) : color

  const onResendOtp = () => {
    if (countDowntimer <= 0) {
      setCountDownTimer(30)
      resendOtp(type === 'EMAIL_OTP' ? email : mobile)
    }
  }

  return (
    <Box onPress={onResendOtp} {...styles.resendTouchable} underlayColor={'TRANSPARENT'}>
      {/* <ModBox show={error?.length > 0}>
        <TextNew type={'bodyMedium14'} color={'ERROR'}>
          {error}
        </TextNew>
      </ModBox> */}
      <Box {...styles.resendContainer}>
        <Text {...styles.didntReceive}>{getString(selectedAppLanguage, 'receivedOtp')}</Text>
        <Text {...styles.didntReceive}>{countDowntimer > 0 ? getString(selectedAppLanguage, 'retryIn') : ''}</Text>
        <Text {...cdtStyles(resendOtpColor).resendText}>
          {countDowntimer > 0 ? '' : getString(selectedAppLanguage, 'resendOtp')}
        </Text>
        <Text {...styles.secondStyle}>{' ' + getCountDownTime(countDowntimer)}</Text>
        <Text {...styles.secondStyle}>{countDowntimer !== 0 ? 's' : ''}</Text>
      </Box>
    </Box>
  )
}

const styles = {
  didntReceive: {
    fontFamily: 'JioType-Medium',
    fontSize: 14,
    letterSpacing: -0.07,
    color: convertHexToRGBA(Colors.BLACK, 65) as ColorOptions,
  } as TextProps,
  resendContainer: {
    flexDirection: 'row',
    align: 'center',
    justify: 'center',
  } as BoxProps,

  resendTouchable: {
    alignSelf: 'center',
    // width: 180,
    marginTop: 8,
    zIndex: 9999,
  } as BoxProps,

  countStyle: {
    fontFamily: 'JioType-Medium',
    fontSize: 14,
    letterSpacing: -0.07,
    color: 'BLACK',
  } as TextProps,

  secondStyle: {
    fontFamily: 'JioType-Medium',
    fontSize: 14,
    letterSpacing: -0.07,
    color: 'BLACK',
  } as TextProps,
}

export { ResendOtp }
